import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { IConversationOrderData } from '../../types/conversations/IConversation';
import { RootStore } from '../../store/types';
import { eContactType } from '../../types/conversations/eContactType';
import { saveConversationAction, saveConversationSlice } from '../../store/conversations/saveConversationSlice';
import { EditConversationDrawerContents } from './EditConversationDrawerContents';
import { closeSideDrawer } from '../../store/sideDrawer/sideDrawerSlice';
import { setConversationOrder } from '../../store/conversations/conversationOrderSlice';
import QueryString from 'qs';
import { useLocation } from 'react-router-dom';
import { conversationSlice } from '../../store/conversations/conversationSlice';
import { useHistory } from 'react-router';
import { clientUrls } from '../../ui-toolkit/rest/ClientUrlFactory';
import { useAppDispatch } from '../../store/store';

const convertQueryStringParamsToQuery = (queryStringParams: QueryString.ParsedQs): Partial<{ autoSave?: boolean }> => {
  const { autoSave } = queryStringParams;
  return {
    autoSave: typeof autoSave === 'string',
  };
};

export const EditConversationDrawerContainer: React.FC = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();

  const search = useLocation().search;
  const query = convertQueryStringParamsToQuery(QueryString.parse(search, { ignoreQueryPrefix: true }));
  const autoSave = query.autoSave;

  const { data: conversationOrder } = useSelector((state: RootStore) => state.conversations.conversationOrder);
  const { fetchStatus, fetchError } = useSelector((state: RootStore) => state.conversations.saveConversation);

  const closeDrawer = () => {
    dispatch(closeSideDrawer());
  };

  const closeModal = () => {
    const orderId = conversationOrder?.orderId;
    if (orderId) history.push(clientUrls.urlFor.orderStatus(orderId));
    dispatch(saveConversationSlice.actions.reset({}));
    dispatch(conversationSlice.actions.reset({}));
    dispatch(setConversationOrder(undefined));
    if (fetchStatus.success) closeDrawer();
  };

  const onSubmit = (formData: IConversationOrderData) => {
    if (conversationOrder?.genesysId) {
      dispatch(setConversationOrder(formData));
      dispatch(
        saveConversationAction({
          id: formData.genesysId,
          contactId: formData.contact ? formData.contact.id : undefined,
          contactType: formData.contact ? formData.contact.contactType : eContactType.None,
          orderId: formData.orderId,
        })
      );
    }
  };

  useEffect(() => {
    const beforeUnloadWarning = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', beforeUnloadWarning);
    return () => {
      window.removeEventListener('beforeunload', beforeUnloadWarning);
    };
  }, []);

  return (
    <EditConversationDrawerContents
      conversationOrder={conversationOrder}
      onSubmit={onSubmit}
      fetchStatus={fetchStatus}
      fetchError={fetchError}
      closeModal={closeModal}
      closeDrawer={closeDrawer}
      autoSave={!!autoSave}
    />
  );
};
